<nb-card>
  <nb-card-header>
    <div class="form-inline" [formGroup]="diaForm">
      <nb-form-field fullWidth>
        <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
        <input
          type="text"
          nbInput
          fullWidth
          shape="semi-round"
          class="form-control"
          placeholder="{{ 'common.strSearch' | translate }}"
          formControlName="fullName"
          [(ngModel)]="strSearch"
          (ngModelChange)="onSearch()"
        />
      </nb-form-field>

      <nb-form-field fullWidth>
        <nb-icon nbPrefix icon="phone-call-outline"></nb-icon>
        <input
          type="text"
          nbInput
          fullWidth
          shape="semi-round"
          class="form-control"
          placeholder="Nhập số điện thoại"
          formControlName="mobile"
          [(ngModel)]="mobile"
          (keydown.enter)="create()"
        />
      </nb-form-field>

      <button
        type="submit"
        nbButton
        outline
        shape="semi-round"
        status="primary"
        size="small"
        [disabled]="submitted || !diaForm.valid"
        [class.btn-pulse]="submitted"
        (click)="create()"
      >
        {{ "buttons.create" | translate }}
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <nb-list>
      <nb-list-item
        *ngFor="
          let item of display
            | paginate : { itemsPerPage: 10, currentPage: page };
          let i = index
        "
        [ngClass]="i % 2 == 0 ? 'content bg1' : 'content bg2'"
      >
        <div>
          <h6 class="text-body">{{ item.fullName }}</h6>
          <div class="detail">
            <a
              *ngIf="item?.mobile"
              href="tel:{{ item.mobile }}"
              class="text-primary link"
            >
              <nb-icon icon="phone-call-outline"></nb-icon> {{ item.mobile }}
            </a>
            <a
              *ngIf="item?.email"
              href="mailto:{{ item.email }}"
              class="text-primary link"
            >
              <nb-icon icon="email-outline"></nb-icon> {{ item.email }}
            </a>
          </div>
        </div>
        <button
          nbButton
          shape="round"
          outline
          status="success"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="selected(item)"
        >
          <nb-icon icon="checkmark-outline"></nb-icon>
        </button>
      </nb-list-item>
    </nb-list>
  </nb-card-body>

  <nb-card-footer>
    <pagination-controls
      (pageChange)="pageChange($event)"
    ></pagination-controls>

    <button
      nbButton
      shape="semi-round"
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
      <span>Đóng</span>
    </button>
  </nb-card-footer>
</nb-card>
